/**
 * AI Provider dashboard — grid of provider cards.
 */

import { useQuery } from '@tanstack/react-query';
import { ProviderCard } from './ProviderCard';
import { listProviders } from '@/lib/api';

interface ProviderDashboardProps {
  onOpenTerminal?: (command: string) => void;
}

export function ProviderDashboard({ onOpenTerminal }: ProviderDashboardProps): React.ReactElement {
  const { data, isLoading, error } = useQuery({
    queryKey: ['providers'],
    queryFn: listProviders,
    staleTime: 10_000,
  });

  if (isLoading) {
    return <div className="text-sm text-muted-foreground">Loading providers...</div>;
  }

  if (error) {
    return (
      <div className="text-sm text-error">
        Failed to load providers: {error instanceof Error ? error.message : 'Unknown error'}
      </div>
    );
  }

  const providers = data?.providers ?? [];

  if (providers.length === 0) {
    return <div className="text-sm text-muted-foreground">No providers configured.</div>;
  }

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
      {providers.map(p => (
        <ProviderCard key={p.id} provider={p} onOpenTerminal={onOpenTerminal} />
      ))}
    </div>
  );
}
